import * as React from 'react';
import { Component } from 'react';
import { getFormComponent } from './utils';

class FourColumnFormSection extends Component {
    constructor(props) {
        super(props);
    }

    render() {      
        return (
            <div style={this.props.visible && !this.props.posted ? {} : { display: 'none' }} className={this.props.isHighlighted ? "form-section highligted" : "form-section"}>
                <div className="row">
                    <div className="col-sm-6 col-md-3 col-xs-50">{<div className="form-fields">
                        {
                            this.props.section.zones[0].formComponents.map((formComponent, key) => {
                                return getFormComponent(formComponent, this.props);
                            })
                        }
                    </div>}</div>
                    <div className="col-sm-6 col-md-3 col-xs-50">{<div className="form-fields">
                        {
                            this.props.section.zones[1].formComponents.map((formComponent, key) => {
                                return getFormComponent(formComponent, this.props);
                            })
                        }
                    </div>}</div>
                    <div className="col-sm-6 col-md-3 col-xs-50">{<div className="form-fields">
                        {
                            this.props.section.zones[2].formComponents.map((formComponent, key) => {
                                return getFormComponent(formComponent, this.props);
                            })
                        }
                    </div>}</div>
                    <div className="col-sm-6 col-md-3 col-xs-50">{<div className="form-fields">
                        {
                            this.props.section.zones[3].formComponents.map((formComponent, key) => {
                                return getFormComponent(formComponent, this.props);
                            })
                        }
                    </div>}</div>
                </div>
            </div>
        )
    }
}

export default FourColumnFormSection;